/* eslint-disable */
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';

function generateArray(table) {
  var out = [];
  var rows = table.querySelectorAll('tr');
  var ranges = [];
  for (var R = 0; R < rows.length; ++R) {
    var outRow = [];
    var row = rows[R];
    var columns = row.querySelectorAll('td');
    for (var C = 0; C < columns.length; ++C) {
      var cell = columns[C];
      var colspan = cell.getAttribute('colspan');
      var rowspan = cell.getAttribute('rowspan');
      var cellValue = cell.innerText;
      if (cellValue !== "" && cellValue == +cellValue) cellValue = +cellValue;

      //Skip ranges
      ranges.forEach(function (range) {
        if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
          for (var i = 0; i <= range.e.c - range.s.c; ++i) outRow.push(null);
        }
      });

      //Handle Row Span
      if (rowspan || colspan) {
        rowspan = rowspan || 1;
        colspan = colspan || 1;
        ranges.push({
          s: {
            r: R,
            c: outRow.length
          },
          e: {
            r: R + rowspan - 1,
            c: outRow.length + colspan - 1
          }
        });
      }
      ;

      //Handle Value
      outRow.push(cellValue !== "" ? cellValue : null);

      //Handle Colspan
      if (colspan)
        for (var k = 0; k < colspan - 1; ++k) outRow.push(null);
    }
    out.push(outRow);
  }
  return [out, ranges];
};

function datenum(v, date1904) {
  if (date1904) v += 1462;
  var epoch = Date.parse(v);
  return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
}

function sheet_from_array_of_arrays(data, opts) {
  var ws = {};
  var range = {
    s: {
      c: 10000000,
      r: 10000000
    },
    e: {
      c: 0,
      r: 0
    }
  };
  for (var R = 0; R != data.length; ++R) {
    for (var C = 0; C != data[R].length; ++C) {
      if (range.s.r > R) range.s.r = R;
      if (range.s.c > C) range.s.c = C;
      if (range.e.r < R) range.e.r = R;
      if (range.e.c < C) range.e.c = C;
      var cell = {
        v: data[R][C]
      };
      if (cell.v == null) continue;
      var cell_ref = XLSX.utils.encode_cell({
        c: C,
        r: R
      });

      if (typeof cell.v === 'number') cell.t = 'n';
      else if (typeof cell.v === 'boolean') cell.t = 'b';
      else if (cell.v instanceof Date) {
        cell.t = 'n';
        cell.z = XLSX.SSF._table[14];
        cell.v = datenum(cell.v);
      } else cell.t = 's';

      ws[cell_ref] = cell;
    }
  }
  if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
  return ws;
}

function Workbook() {
  if (!(this instanceof Workbook)) return new Workbook();
  this.SheetNames = [];
  this.Sheets = {};
}

function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
}

export function export_table_to_excel(id) {
  var theTable = document.getElementById(id);
  var oo = generateArray(theTable);
  var ranges = oo[1];

  /* original data */
  var data = oo[0];
  var ws_name = "SheetJS";

  var wb = new Workbook(),
    ws = sheet_from_array_of_arrays(data);

  /* add ranges to worksheet */
  ws['!merges'] = ranges;

  /* add worksheet to workbook */
  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;

  var wbout = XLSX.write(wb, {
    bookType: 'xlsx',
    bookSST: false,
    type: 'binary'
  });

  saveAs(new Blob([s2ab(wbout)], {
    type: "application/octet-stream"
  }), "test.xlsx")
}

export function export_json_to_excel({
   title,
   multiHeader = [],
   header,
   data,
   filename,
   merges = [],
   autoWidth = true,
   width,
   bookType = 'xlsx',
   myRowFont = ['1']
 } = {}) {
  /* original data */
  filename = filename || 'excel-list'
  data = [...data]
  //設置表頭和標題
  data.unshift(header);
  data.unshift(title);
  for (let i = multiHeader.length - 1; i > -1; i--) {
    data.unshift(multiHeader[i])
  }

  var ws_name = "SheetJS";
  var wb = new Workbook(),
  ws = sheet_from_array_of_arrays(data);

  if (merges.length > 0) {
    if (!ws['!merges']) ws['!merges'] = [];
    merges.forEach(item => {
      ws['!merges'].push(XLSX.utils.decode_range(item))
    })
  }

  //是否自動設置寬度
  if (autoWidth) {
    /*設置worksheet每列的最大寬度*/
    const colWidth = data.map(row => row.map(val => {
      /*先判斷是否為null/undefined*/
      if (val == null) {
        return {
          'wch': 30
        };
      }
      /*再判斷是否為中文*/
      else if (val.toString().charCodeAt(0) > 255) {
        return {
          'wch': val.toString().length * 2.5
        };
      } else {
        return {
          'wch': val.toString().length * 2.5
        };
      }
    }))
    /*以第一行為初始值*/
    let result = colWidth[0];
    for (let i = 1; i < colWidth.length; i++) {
      for (let j = 0; j < colWidth[i].length; j++) {
        if (result[j]['wch'] < colWidth[i][j]['wch']) {
          result[j]['wch'] = colWidth[i][j]['wch'];
        }
      }
    }
    ws['!cols'] = result;
  }else {
    /*設置worksheet每列的最大寬度*/
    const colWidth = data.map(row => row.map(val => {
      /*先判斷是否為null/undefined*/
      if (val == null) {
        return {
          'wch': width
        };
      }
      /*再判斷是否為中文*/
      else if (val.toString().charCodeAt(0) > 255) {
        return {
          'wch': width
        };
      } else {
        return {
          'wch': width
        };
      }
    }))
    /*以第一行為初始值*/
    let result = colWidth[0];
    for (let i = 1; i < colWidth.length; i++) {
      for (let j = 0; j < colWidth[i].length; j++) {
        if (result[j]['wch'] < colWidth[i][j]['wch']) {
          result[j]['wch'] = colWidth[i][j]['wch'];
        }
      }
    }
    ws['!cols'] = result;
  }

  /* add worksheet to workbook */
  wb.SheetNames.push(ws_name);
  wb.Sheets[ws_name] = ws;
  var dataInfo = wb.Sheets[wb.SheetNames[0]];

  const borderAll = {  //單元格外側框線
    top: {
      style: 'thin'
    },
    bottom: {
      style: 'thin'
    },
    left: {
      style: 'thin'
    },
    right: {
      style: 'thin'
    }
  };
  
  //給所有單元格加上邊框
  for (var i in dataInfo) {
    if (i === '!ref' || i === '!cols' ) {

    } else {
      dataInfo[i + ''].s = {
        border: borderAll
      }
    }
  }

  // 這是表頭行的樣式
  var tableTitleFont = {
    font: {
      name: '宋體',
      sz: 18,
      bold: true,
      italic: false,
      underline: false
    },
    alignment: {
      horizontal: "center",
      vertical: "center"
    },
    fill: {
      //單元格背景色
      //fgColor: {rgb: "008000"},
    },
    border:borderAll
  };

  for(var q in myRowFont){
    for (var b in dataInfo) {
    if (b.indexOf(myRowFont[q]) > -1) {
      dataInfo[b].s = tableTitleFont
    }
  }

  }

  var wbout = XLSX.write(wb, {
    bookType: bookType,
    bookSST: false,
    type: 'binary'
  });
  saveAs(new Blob([s2ab(wbout)], {
    type: "application/octet-stream"
  }), `${filename}.${bookType}`);
}

// 專門用於銀行記錄匯出的函數（簡化版，不包含樣式）
export function export_bank_records_to_excel({
  title = '銀行進支記錄',
  data,
  filename = '銀行進支記錄',
  bookType = 'xlsx'
} = {}) {
  if (!data || data.length === 0) {
    console.warn('沒有資料可匯出');
    return;
  }

  // 準備資料
  const headers = ['日期', '進支詳情', '進支方式', '存入', '支出', '儲蓄/往來', '備注'];
  const excelData = [];

  // 添加標題行
  excelData.push([title, '', '', '', '', '', '']);

  // 添加表頭
  excelData.push(headers);

  // 添加資料行
  data.forEach(row => {
    excelData.push([
      row['日期'] || '',
      row['進支詳情'] || '',
      row['進支方式'] || '',
      row['存入'] || '',
      row['支出'] || '',
      row['儲蓄/往來'] || '',
      row['備注'] || ''
    ]);
  });

  // 使用 XLSX 標準方法建立工作表
  const ws = XLSX.utils.aoa_to_sheet(excelData);

  // 合併標題行
  ws['!merges'] = [
    { s: { c: 0, r: 0 }, e: { c: 6, r: 0 } }
  ];

  // 設置欄位寬度
  ws['!cols'] = [
    { wch: 12 }, // 日期
    { wch: 30 }, // 進支詳情
    { wch: 25 }, // 進支方式
    { wch: 12 }, // 存入
    { wch: 12 }, // 支出
    { wch: 12 }, // 儲蓄/往來
    { wch: 20 }, // 備注
  ];

  // 建立工作簿
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "銀行記錄");

  // 生成檔案名稱
  const currentDate = new Date();
  const dateString = currentDate.getFullYear() +
    '-' + String(currentDate.getMonth() + 1).padStart(2, '0') +
    '-' + String(currentDate.getDate()).padStart(2, '0');

  const recordCount = data.length;
  const finalFilename = `${title}_${recordCount}項_${dateString}.${bookType}`;

  // 匯出檔案
  XLSX.writeFile(wb, finalFilename);
}

// 使用 ExcelJS 的專業級銀行記錄匯出函數（支援完整樣式）
export async function export_bank_records_to_excel_styled({
  title = '銀行進支記錄',
  data,
  filename = '銀行進支記錄',
  bookType = 'xlsx'
} = {}) {
  if (!data || data.length === 0) {
    console.warn('沒有資料可匯出');
    return;
  }

  // 建立新的工作簿
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('銀行記錄', {
    pageSetup: {
      paperSize: 9, // A4
      orientation: 'landscape',
      fitToPage: true,
      fitToHeight: 1,
      fitToWidth: 1
    }
  });

  // 添加標題行（第一行）
  const titleRow = worksheet.addRow([title, '', '', '', '', '', '']);

  // 合併標題行儲存格
  worksheet.mergeCells('A1:G1');

  // 設定欄位寬度（不使用 columns 以避免自動添加表頭）
  worksheet.getColumn(1).width = 15;  // 日期
  worksheet.getColumn(2).width = 35;  // 進支詳情
  worksheet.getColumn(3).width = 30;  // 進支方式
  worksheet.getColumn(4).width = 15;  // 存入
  worksheet.getColumn(5).width = 15;  // 支出
  worksheet.getColumn(6).width = 15;  // 儲蓄/往來
  worksheet.getColumn(7).width = 25;  // 備注

  // 標題行樣式
  titleRow.height = 30; // 減少標題行高度
  const titleCell = worksheet.getCell('A1');
  titleCell.font = {
    name: '微軟正黑體',
    size: 14, // 減小字體大小
    bold: true,
    color: { argb: 'FF000000' }
  };
  titleCell.alignment = {
    vertical: 'middle',
    horizontal: 'center'
  };
  titleCell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFE7E6E6' }
  };
  titleCell.border = {
    top: { style: 'thin', color: { argb: 'FF000000' } },
    left: { style: 'thin', color: { argb: 'FF000000' } },
    bottom: { style: 'thin', color: { argb: 'FF000000' } },
    right: { style: 'thin', color: { argb: 'FF000000' } }
  };

  // 添加表頭行
  const headerRow = worksheet.addRow(['日期', '進支詳情', '進支方式', '存入', '支出', '儲蓄/往來', '備注']);

  // 表頭行樣式
  headerRow.height = 25;
  headerRow.eachCell((cell, colNumber) => {
    cell.font = {
      name: '微軟正黑體',
      size: 12,
      bold: true,
      color: { argb: 'FF000000' }
    };
    cell.alignment = {
      vertical: 'middle',
      horizontal: 'center'
    };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFD9D9D9' }
    };
    cell.border = {
      top: { style: 'thin', color: { argb: 'FF000000' } },
      left: { style: 'thin', color: { argb: 'FF000000' } },
      bottom: { style: 'thin', color: { argb: 'FF000000' } },
      right: { style: 'thin', color: { argb: 'FF000000' } }
    };
  });

  // 添加資料行
  data.forEach((row, index) => {
    const dataRow = worksheet.addRow([
      row['日期'] || '',
      row['進支詳情'] || '',
      row['進支方式'] || '',
      row['存入'] || '',
      row['支出'] || '',
      row['儲蓄/往來'] || '',
      row['備注'] || ''
    ]);

    // 資料行樣式
    dataRow.height = 20;
    dataRow.eachCell((cell, colNumber) => {
      cell.font = {
        name: '微軟正黑體',
        size: 11,
        color: { argb: 'FF000000' }
      };

      // 根據欄位類型設定對齊方式
      if (colNumber === 4 || colNumber === 5) { // 存入、支出欄位
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'right'
        };
        // 如果是數字，設定數字格式
        if (cell.value && !isNaN(cell.value)) {
          cell.numFmt = '#,##0.00';
        }
      } else if (colNumber === 1) { // 日期欄位
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };
      } else { // 其他欄位
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'left'
        };
      }

      // 設定邊框
      cell.border = {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      };

      // 交替行背景色
      if (index % 2 === 1) {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFF8F8F8' }
        };
      }
    });
  });

  // 凍結窗格（固定標題和表頭）
  worksheet.views = [
    { state: 'frozen', xSplit: 0, ySplit: 2 }
  ];

  // 生成檔案名稱
  const currentDate = new Date();
  const dateString = currentDate.getFullYear() +
    '-' + String(currentDate.getMonth() + 1).padStart(2, '0') +
    '-' + String(currentDate.getDate()).padStart(2, '0');

  const recordCount = data.length;
  const finalFilename = `${title}_${recordCount}項_${dateString}.${bookType}`;

  // 生成 Excel 檔案並下載
  try {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    saveAs(blob, finalFilename);
    return true;
  } catch (error) {
    console.error('Excel 匯出失敗:', error);
    return false;
  }
}

// 使用 ExcelJS 的專業級薪金支出記錄匯出函數（支援完整樣式）
export async function export_expenditures_to_excel_styled({
  title = '薪金支出記錄',
  data,
  filename = '薪金支出記錄',
  bookType = 'xlsx'
} = {}) {
  if (!data || data.length === 0) {
    console.warn('沒有資料可匯出');
    return false;
  }

  // 建立新的工作簿
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('薪金支出記錄', {
    pageSetup: {
      paperSize: 9, // A4
      orientation: 'landscape',
      fitToPage: true,
      fitToHeight: 1,
      fitToWidth: 1
    }
  });

  // 設定欄位寬度
  worksheet.columns = [
    { width: 12 }, // 編號
    { width: 15 }, // 收支者
    { width: 15 }, // 薪資形式
    { width: 15 }, // 出糧月份
    { width: 12 }, // 出糧日期
    { width: 60 }, // 工資詳情 - 增加寬度以容納更多內容
    { width: 20 }, // 出糧備註
    { width: 15 }, // 收款方式
    { width: 15 }, // 支票號碼
    { width: 15 }, // 實發工資
    { width: 18 }, // 公司總支出金額
    { width: 15 }, // 薪金支出狀態
    { width: 15 }, // 創建日期
  ];

  // 添加頁首說明文字
  const headerText1 = 'PS. 實發工資 = 各項工資 + 各項佣金/花紅 + 各項其他津貼 + 各項逾時工作金額 - 各項強積金(僱員)';
  const headerText2 = 'PS. 公司總支出金額 = 各項工資 + 各項佣金/花紅 + 各項其他津貼 + 各項逾時工作金額 + 各項強積金(僱主)';

  const headerRow1 = worksheet.addRow([headerText1]);
  const headerRow2 = worksheet.addRow([headerText2]);

  // 合併頁首說明文字
  worksheet.mergeCells(1, 1, 1, 13);
  worksheet.mergeCells(2, 1, 2, 13);

  // 設定頁首說明文字樣式
  [headerRow1, headerRow2].forEach(row => {
    row.height = 20;
    row.getCell(1).font = {
      name: '微軟正黑體',
      size: 10,
      color: { argb: 'FF666666' }
    };
    row.getCell(1).alignment = {
      vertical: 'middle',
      horizontal: 'left'
    };
  });

  // 添加空行
  worksheet.addRow([]);

  // 添加標題行
  const titleRow = worksheet.addRow([title]);
  worksheet.mergeCells(4, 1, 4, 13);
  titleRow.height = 30;
  titleRow.getCell(1).font = {
    name: '微軟正黑體',
    size: 16,
    bold: true,
    color: { argb: 'FF000000' }
  };
  titleRow.getCell(1).alignment = {
    vertical: 'middle',
    horizontal: 'center'
  };
  titleRow.getCell(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFE6F3FF' }
  };

  // 添加表頭
  const headers = ['編號', '收支者', '薪資形式', '出糧月份', '出糧日期', '工資詳情', '出糧備註', '收款方式', '支票號碼', '實發工資', '公司總支出金額', '薪金支出狀態', '創建日期'];
  const headerRow = worksheet.addRow(headers);
  headerRow.height = 25;

  // 表頭樣式
  headerRow.eachCell((cell, colNumber) => {
    cell.font = {
      name: '微軟正黑體',
      size: 12,
      bold: true,
      color: { argb: 'FFFFFFFF' }
    };
    cell.alignment = {
      vertical: 'middle',
      horizontal: 'center'
    };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF4472C4' }
    };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };
  });

  // 添加資料行
  data.forEach((row, index) => {
    const dataRow = worksheet.addRow([
      row['編號'] || '',
      row['收支者'] || '',
      row['薪資形式'] || '',
      row['出糧月份'] || '',
      row['出糧日期'] || '',
      row['工資詳情'] || '',
      row['出糧備註'] || '',
      row['收款方式'] || '',
      row['支票號碼'] || '',
      row['實發工資'] || '',
      row['公司總支出金額'] || '',
      row['薪金支出狀態'] || '',
      row['創建日期'] || ''
    ]);

    // 計算工資詳情欄位的行數來設定適當的行高
    const salaryDetailsContent = row['工資詳情'] || '';
    const lineCount = salaryDetailsContent.split('\n').length;
    // 每行約需要 12 像素，最小高度 24，最大高度 180
    const calculatedHeight = Math.max(24, Math.min(180, lineCount * 12));

    // 資料行樣式
    dataRow.height = calculatedHeight;
    dataRow.eachCell((cell, colNumber) => {
      cell.font = {
        name: '微軟正黑體',
        size: 10,
        color: { argb: 'FF000000' }
      };

      // 根據欄位類型設定對齊方式
      if (colNumber === 10 || colNumber === 11) { // 實發工資、公司總支出金額欄位
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'right'
        };
      } else if (colNumber === 1 || colNumber === 4 || colNumber === 5 || colNumber === 13) { // 編號、出糧日期、創建日期欄位
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };
      } else if (colNumber === 6) { // 工資詳情欄位
        cell.alignment = {
          vertical: 'top',
          horizontal: 'left',
          wrapText: true
        };
        // 為工資詳情欄位設定特殊樣式
        cell.font = {
          name: '微軟正黑體',
          size: 9, // 稍微小一點的字體以容納更多內容
          color: { argb: 'FF000000' }
        };
      } else { // 其他欄位
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'left'
        };
      }

      // 設定邊框
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };

      // 交替行背景色
      if (index % 2 === 1) {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFF8F9FA' }
        };
      }
    });
  });

  // 生成檔案名稱
  const currentDate = new Date();
  const dateString = currentDate.getFullYear() +
    '-' + String(currentDate.getMonth() + 1).padStart(2, '0') +
    '-' + String(currentDate.getDate()).padStart(2, '0');

  const recordCount = data.length;
  const finalFilename = `${title}_${recordCount}項_${dateString}.${bookType}`;

  // 生成 Excel 檔案並下載
  try {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    saveAs(blob, finalFilename);
    return true;
  } catch (error) {
    console.error('Excel 匯出失敗:', error);
    return false;
  }
}

// 使用 ExcelJS 的專業級預支記錄匯出函數（支援完整樣式）
export async function export_advance_payments_to_excel_styled({
  title = '預支記錄',
  data,
  filename = '預支記錄',
  bookType = 'xlsx'
} = {}) {
  if (!data || data.length === 0) {
    console.warn('沒有資料可匯出');
    return false;
  }

  // 建立新的工作簿
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('預支記錄', {
    pageSetup: {
      paperSize: 9, // A4
      orientation: 'landscape',
      fitToPage: true,
      fitToHeight: 1,
      fitToWidth: 1
    }
  });

  // 設定欄位寬度
  worksheet.columns = [
    { width: 12 }, // 編號
    { width: 15 }, // 申請人
    { width: 50 }, // 款項摘要
    { width: 15 }, // 總預支金額
    { width: 15 }, // 總接收金額
    { width: 23 }, // 已使用金額(已批核)
    { width: 15 }, // 待批核金額
    { width: 15 }, // 已拒絕金額
    { width: 15 }, // 已退還金額
    { width: 12 }, // 餘額
    { width: 15 }, // 發票編號
    { width: 25 }, // 工程地址
    { width: 16 }, // 預支申請日期
    { width: 15 }, // 收款方式
    { width: 15 }, // 支票號碼
    { width: 12 }, // 收款日期
    { width: 15 }, // 預支狀態
    { width: 25 }, // 預支備註
    { width: 15 }, // 創建日期
  ];

  // 添加標題行
  const titleRow = worksheet.addRow([title]);
  worksheet.mergeCells(1, 1, 1, 19);
  titleRow.height = 30;
  titleRow.getCell(1).font = {
    name: '微軟正黑體',
    size: 16,
    bold: true,
    color: { argb: 'FF000000' }
  };
  titleRow.getCell(1).alignment = {
    vertical: 'middle',
    horizontal: 'center'
  };
  titleRow.getCell(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFE6F3FF' }
  };

  // 添加表頭
  const headers = ['編號', '申請人', '款項摘要', '總預支金額', '總接收金額', '已使用金額(已批核)', '待批核金額', '已拒絕金額', '已退還金額', '餘額', '發票編號', '工程地址', '預支申請日期', '收款方式', '支票號碼', '收款日期', '預支狀態', '預支備註', '創建日期'];
  const headerRow = worksheet.addRow(headers);
  headerRow.height = 25;

  // 表頭樣式
  headerRow.eachCell((cell, colNumber) => {
    cell.font = {
      name: '微軟正黑體',
      size: 12,
      bold: true,
      color: { argb: 'FFFFFFFF' }
    };
    cell.alignment = {
      vertical: 'middle',
      horizontal: 'center'
    };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF4472C4' }
    };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };
  });

  // 添加資料行
  data.forEach((row, index) => {
    const dataRow = worksheet.addRow([
      row['編號'] || '',
      row['申請人'] || '',
      row['款項摘要'] || '',
      row['總預支金額'] || '',
      row['總接收金額'] || '',
      row['已使用金額(已批核)'] || '',
      row['待批核金額'] || '',
      row['已拒絕金額'] || '',
      row['已退還金額'] || '',
      row['餘額'] || '',
      row['發票編號'] || '',
      row['工程地址'] || '',
      row['預支申請日期'] || '',
      row['收款方式'] || '',
      row['支票號碼'] || '',
      row['收款日期'] || '',
      row['預支狀態'] || '',
      row['預支備註'] || '',
      row['創建日期'] || '',
    ]);

    // 計算款項摘要欄位的行數來設定適當的行高
    const summaryContent = row['款項摘要'] || '';
    const lineCount = summaryContent.split('\n').length;
    // 每行約需要 12 像素，最小高度 24，最大高度 180
    const calculatedHeight = Math.max(24, Math.min(180, lineCount * 12));

    // 資料行樣式
    dataRow.height = calculatedHeight;
    dataRow.eachCell((cell, colNumber) => {
      cell.font = {
        name: '微軟正黑體',
        size: 10,
        color: { argb: 'FF000000' }
      };

      // 根據欄位類型設定對齊方式
      if (colNumber >= 7 && colNumber <= 13) { // 金額欄位 (總預支金額到餘額)
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'right'
        };
      } else if (colNumber === 1 || colNumber === 4 || colNumber === 6 || colNumber === 18) { // 編號、發票編號、預支日期、創建日期欄位
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };
      } else if (colNumber === 3) { // 款項摘要欄位
        cell.alignment = {
          vertical: 'top',
          horizontal: 'left',
          wrapText: true
        };
        // 為款項摘要欄位設定特殊樣式
        cell.font = {
          name: '微軟正黑體',
          size: 9, // 稍微小一點的字體以容納更多內容
          color: { argb: 'FF000000' }
        };
      } else { // 其他欄位
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'left'
        };
      }

      // 設定邊框
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };

      // 交替行背景色
      if (index % 2 === 1) {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFF8F9FA' }
        };
      }
    });
  });

  // 生成檔案名稱
  const currentDate = new Date();
  const dateString = currentDate.getFullYear() +
    '-' + String(currentDate.getMonth() + 1).padStart(2, '0') +
    '-' + String(currentDate.getDate()).padStart(2, '0');

  const recordCount = data.length;
  const finalFilename = `${title}_${recordCount}項_${dateString}.${bookType}`;

  // 生成 Excel 檔案並下載
  try {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    saveAs(blob, finalFilename);
    return true;
  } catch (error) {
    console.error('Excel 匯出失敗:', error);
    return false;
  }
}

// 使用 ExcelJS 的專業級報銷記錄匯出函數（支援完整樣式）
export async function export_claims_to_excel_styled({
  title = '報銷記錄',
  data,
  filename = '報銷記錄',
  bookType = 'xlsx'
} = {}) {
  if (!data || data.length === 0) {
    console.warn('沒有資料可匯出');
    return false;
  }

  // 建立新的工作簿
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('報銷記錄', {
    pageSetup: {
      paperSize: 9, // A4
      orientation: 'landscape',
      fitToPage: true,
      fitToHeight: 1,
      fitToWidth: 1
    }
  });

  // 設定欄位寬度
  worksheet.columns = [
    { width: 12 }, // 編號
    { width: 25 }, // 報銷發票
    { width: 12 }, // 報銷日期
    { width: 15 }, // 付款方式
    { width: 25 }, // 報銷原因
    { width: 50 }, // 報銷詳情
    { width: 15 }, // 報銷者
    { width: 15 }, // 報銷金額
    { width: 15 }, // 報銷狀態
    { width: 15 }, // 創建日期
  ];

  // 添加標題行
  const titleRow = worksheet.addRow([title]);
  worksheet.mergeCells(1, 1, 1, 10);
  titleRow.height = 30;
  titleRow.getCell(1).font = {
    name: '微軟正黑體',
    size: 16,
    bold: true,
    color: { argb: 'FF000000' }
  };
  titleRow.getCell(1).alignment = {
    vertical: 'middle',
    horizontal: 'center'
  };
  titleRow.getCell(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFE6F3FF' }
  };

  // 添加表頭
  const headers = ['編號', '報銷發票', '報銷日期', '付款方式', '報銷原因', '報銷詳情', '報銷者', '報銷金額', '報銷狀態', '創建日期'];
  const headerRow = worksheet.addRow(headers);
  headerRow.height = 25;

  // 表頭樣式
  headerRow.eachCell((cell, colNumber) => {
    cell.font = {
      name: '微軟正黑體',
      size: 12,
      bold: true,
      color: { argb: 'FFFFFFFF' }
    };
    cell.alignment = {
      vertical: 'middle',
      horizontal: 'center'
    };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF4472C4' }
    };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };
  });

  // 添加資料行
  data.forEach((row, index) => {
    const dataRow = worksheet.addRow([
      row['編號'] || '',
      row['報銷發票'] || '',
      row['報銷日期'] || '',
      row['付款方式'] || '',
      row['報銷原因'] || '',
      row['報銷詳情'] || '',
      row['報銷者'] || '',
      row['報銷金額'] || '',
      row['報銷狀態'] || '',
      row['創建日期'] || ''
    ]);

    // 計算報銷詳情欄位的行數來設定適當的行高
    const detailsContent = row['報銷詳情'] || '';
    const lineCount = detailsContent.split('\n').length;
    // 每行約需要 12 像素，最小高度 24，最大高度 180
    const calculatedHeight = Math.max(24, Math.min(180, lineCount * 12));

    // 資料行樣式
    dataRow.height = calculatedHeight;
    dataRow.eachCell((cell, colNumber) => {
      cell.font = {
        name: '微軟正黑體',
        size: 10,
        color: { argb: 'FF000000' }
      };

      // 根據欄位類型設定對齊方式
      if (colNumber === 8) { // 報銷金額欄位
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'right'
        };
      } else if (colNumber === 1 || colNumber === 3 || colNumber === 10) { // 編號、報銷日期、創建日期欄位
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };
      } else if (colNumber === 6) { // 報銷詳情欄位
        cell.alignment = {
          vertical: 'top',
          horizontal: 'left',
          wrapText: true
        };
        // 為報銷詳情欄位設定特殊樣式
        cell.font = {
          name: '微軟正黑體',
          size: 9, // 稍微小一點的字體以容納更多內容
          color: { argb: 'FF000000' }
        };
      } else { // 其他欄位
        cell.alignment = {
          vertical: 'middle',
          horizontal: 'left'
        };
      }

      // 設定邊框
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };

      // 交替行背景色
      if (index % 2 === 1) {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFF8F9FA' }
        };
      }
    });
  });

  // 生成檔案名稱
  const currentDate = new Date();
  const dateString = currentDate.getFullYear() +
    '-' + String(currentDate.getMonth() + 1).padStart(2, '0') +
    '-' + String(currentDate.getDate()).padStart(2, '0');

  const recordCount = data.length;
  const finalFilename = `${title}_${recordCount}項_${dateString}.${bookType}`;

  // 生成 Excel 檔案並下載
  try {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    saveAs(blob, finalFilename);
    return true;
  } catch (error) {
    console.error('Excel 匯出失敗:', error);
    return false;
  }
}
